import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};
//
export const createMarketingBanner = async (formValues) => {
  const formData = new FormData();
  formData.append("BannerTitle", formValues.BannerTitle);
  formData.append("BannerLink", formValues.BannerLink);
  formData.append("Published", formValues.Published.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder);

  if (formValues.ImageFile) {
    formData.append("ImageFile", formValues.ImageFile);
  } else {
    formData.append("ImageFile", null);
  }
  const response = await axiosInstance.post("marketing-banner", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};
export const updateMarketingBanner = async (formValues) => {
  const formData = new FormData();
  formData.append("Id", formValues.Id);
  formData.append("BannerTitle", formValues.BannerTitle);
  formData.append("BannerLink", formValues.BannerLink);
  formData.append("Published", formValues.Published.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder);

  if (formValues.ImageFile) {
    formData.append("ImageFile", formValues.ImageFile);
  } else {
    formData.append("ImageFile", null);
  }
  const response = await axiosInstance.put("marketing-banner", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};

export const fetchMarketingBanners = async () => {
  const response = await axiosInstance.get("marketing-banner", { headers });
  return response.data;
};

export const fetchMarketingBannerById = async (id) => {
  const response = await axiosInstance.get(`marketing-banner/${id}`, {
    headers,
  });
  return response.data;
};

export const publishMarketingBanner = async (id) => {
  return await await axiosInstance.patch(`marketing-banner/${id}/publish`, {
    headers,
  });
};

export const unPublishMarketingBanner = async (id) => {
  return await await axiosInstance.patch(`marketing-banner/${id}/unpublish`, {
    headers,
  });
};

export const deleteMarketingBanner = async (id) => {
  return await axiosInstance.delete(`marketing-banner/${id}`, { headers });
};
